// extracted by mini-css-extract-plugin
export default {"container":"Feed_container__n3Ipc","infiniteFeedPosts":"Feed_infiniteFeedPosts__F7u3k","post":"Feed_post__t2-QV"};